import MixColors from "../../../../src/components/pages/mix-colors/MixColors.js";
import * as React from 'react';
export default {
  MixColors,
  React
};